/**
 * @file editopic-state.js
 */
export default {
    routeName: '',
    extConfig: {},
    renderConfig: {},
    initPlaceholder: '',
    tokenImg: '',
    token: '',
    activeTag: -1,
    activeTagIndex: 0,
    pageConfig: {},
    finalExtName: [],
    dynamicTags: [],
    titleConfig: {
        type: 'input',
        label: '帖子标题',
        isTitle: true,
        defaultValue: '',
        placeholder: '请输入帖子标题',
        validations: {
            required: 1,
            maxLength: 50,
            minLength: 1
        }
    },
    notIssueTitleLen: 50,
    notIssueTitlePlaceholder: '请输入帖子标题',
    issueTitleLen: 50,
    issueTitlePlaceholder: '【分类】+【属性】+【描述】',
    finalResult: {},
    hasNull: false,
    topicId: '',
    isInputSthing: false,
    titleSugList: [],
    secretTip: '该字段为保密信息，仅发帖人与官方可见'
};
